module.exports = __webpack_public_path__ + "static/media/listEmbraconMobile.98a14c50.jpg";